import { DiagonalVariantCalc } from "../types/types";
import { degreesToRadians, DistanceVec2, pointFromAngle, rayIntersectVertical } from "./util";
export function CalcBoardParamFromDiagonal(a, x, shiftFront = 0, shiftBack = 0, h, variant, pointStart = [0, 0]) {
    const booardParams = { dBoard: 0, dFull: 0, dSFront: 0, dSBack: 0, h: 0 };
    const degA = degreesToRadians(a);
    if (variant === DiagonalVariantCalc.Bottom) {
        //обход по нижней линии доски
        const p01 = pointFromAngle(pointStart, Math.PI / 2 + degA, h);
        const p02 = rayIntersectVertical(p01, x, degA);
        const pH = rayIntersectVertical(p01, 0, degA);
        booardParams.h = pH[1];
        booardParams.dBoard = DistanceVec2(p01, p02); // длина по верхней
        const test = DistanceVec2([0, 0], p01);
        if (shiftFront > 0) {
            const _pSL = rayIntersectVertical(pointStart, -shiftFront, degA - Math.PI);
            const pSL = pointFromAngle(_pSL, Math.PI / 2 + degA, h);
            booardParams.dSFront = DistanceVec2(p01, pSL) || 0; // длина по верхней
        }
        if (shiftFront > 0) {
            const pSR = rayIntersectVertical(p02, x + shiftBack, degA);
            booardParams.dSBack = DistanceVec2(p02, pSR) || 0; // длина по верхней
        }
        booardParams.dFull = booardParams.dSFront + booardParams.dBoard + booardParams.dSBack;
    }
    else if (variant === DiagonalVariantCalc.Top) {
        const p01 = pointFromAngle(pointStart, degreesToRadians(a + 180), h);
        const _pSL = rayIntersectVertical(pointStart, -shiftFront, degreesToRadians(a + 90 + 180));
        const pSL = pointFromAngle(_pSL, degreesToRadians(a + 180), h);
        const p02 = rayIntersectVertical(pSL, x, degreesToRadians(a));
    }
    else if (variant === DiagonalVariantCalc.Center) {
    }
    else if (variant === DiagonalVariantCalc.Oblique) {
    }
    return booardParams;
}
